





















































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { SwContentToolbar } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SwSpinningProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-progress';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { SwTable, TableEntry, TableColumnConfig, TableFooterConfig, TableEntrySelectingEventData, SortedColumnInfo, ColumnSortRequestData } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwExpandableTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { CreateElement, VNode } from 'vue';
import { RootStoreState } from '@/store';
import { State } from 'vuex-class';
import QuotehistoryModal from './quotehistory-modal.vue';
import QuotenotesModal from './quotenotes-modal.vue';
import Showquotedetails from '../../msw-quotecomponent/quotehistory/quotedetails/showquotedetail.vue';
import { currentUserKey } from '@/shared/msw-constants';

const cssPrefix = 'snb-renewaltable';

@Component({
  components: {
    ...UUIFComponents,
    SwSpinningProgress,
    SwContentToolbar,
    SwTable,
    SwDropMenu,
    SwIconButton,
    SwCheckbox,
    SwButton,
    SwExpandableTextfield,
    QuotehistoryModal,
    QuotenotesModal,
    Showquotedetails,
  }, directives: {
    tooltip,
  },
})

export default class Renewaltable extends SwExtendedVue {
  @State((state: RootStoreState) => state.RenewalManagerStoreModule.quoteList)
  quoteList: [];
  @Prop()
  tabName: string[];
  @Prop()
  tabid: string;
  totalQuotes: number = 0;
  cssPrefix = cssPrefix;
  searchValue: string = '';
  selectedCategory: string = 'customer';
  menuOpened: boolean = false;
  selectedQuoteId: string = '';
  sortedColumns: SortedColumnInfo[] = [];
  isPartner: boolean = false;
  get filterItems(): DropMenuItem[] {
    return [
      {
        id: 'customer',
        content: this.$t('productClaims.customer')
        .toString(),
      },
      {
        id: 'equoteId',
        content: this.$t('quote.quoteID')
        .toString(),
      },
      {
        id: 'resellerDecideBy',
        content: this.$t('renewalManager.decideByDate')
        .toString(),
      },
      {
        id: 'status',
        content: this.$t('common.status')
        .toString(),
      },
      {
        id: 'expirationDate',
        content:  this.$t('quoteHistory.expDate')
        .toString(),
      },
      {
        id: 'totalPrice',
        content: this.$t('quoteHistory.amt')
        .toString(),
      },
      {
        id: 'resellerManaged',
        content: this.$t('renewalManager.programManaged')
        .toString(),
      },
      {
        id: 'programManaged',
        content: this.$t('renewalManager.resellerManaged')
        .toString(),
      },
    ];
  }
  messages = {
    due: this.$t('renewalManager.dueMsg')
    .toString(),
    urgent: this.$t('renewalManager.urgentMsg')
    .toString(),
    overdue: this.$t('renewalManager.overdueMsg')
    .toString(),
    expired: this.$t('renewalManager.expiredMsg')
    .toString(),
  };
  renewTablColumnConfig: TableColumnConfig[] = [];
  renewTableData: TableEntry[] = [];
  tempRenewTableData: TableEntry[] = [];
  selectedMenuItem: any = '';
  selectedTableRows: any[] = [];
  selectedRows : any[] = [];
  equoteIds: any[] = [];

  showQuoteHistory: boolean = false;
  showQuoteNotes: boolean = false;

  // filter and serach
  textExpanded : boolean = false;
  search: string = '';
  filterSearch: string = '';
  appliedFilter : any = [];
  addFilterOptionBack: any = [];
  showSearchedTextInHeader : boolean = false;
  showFilterSearch: boolean = false;
  filterHoverValues : boolean = false;

  showQuoteDetails: boolean = false;
  enableTooltip: boolean = true;

  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  onClickMenuButton(): void {
    this.menuOpened = !this.menuOpened;
  }

  onCloseAll() {
    this.searchValue = '';
    this.selectedMenuItem = '';
    this.menuOpened = false;
  }

  makeTableConfig() {
    const makeElipsis = (item: string, size = 20) => {
      if (item.length > size) {
        return `${item.slice(0, size)}...`;
      } return item;
    };
    const tableConfig: TableColumnConfig[] = [
      {
        key: 'selection',
        type: 'selection',
      },
      {
        key: 'index',
        type: 'index',
      },
      {
        key: 'customer',
        dataKey: 'customer',
        title: this.$t('productClaims.customer')
        .toString(),
        sorter: true,
        width: 200,
        tooltip: {
          content: this.$t('renewalManager.custName')
          .toString(),
          compact: true,
        },
        // tslint:disable-next-line:no-unused
      },
      {
        key: 'equoteId',
        dataKey: 'equoteId',
        title: this.$t('quote.quoteID')
        .toString(),
        sorter: true,
        width: 100,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div v-tooltip={{ placement: 'top', persistent: false, compact: true, content: data.entry.equoteId }}>
              <a style="font-weight: bold" onClick={() => this.openQuoteDetails(data.entry.equoteId)} >{ makeElipsis(data.entry.equoteId, 26) }</a>
            </div>
          ) as VNode;
        },
      },
      {
        key: 'resellerDecideBy',
        dataKey: 'resellerDecideBy',
        title: this.$t('renewalManager.decideByDate')
        .toString(),
        sorter: true,
        width: 200,
      },
      {
        key: 'status',
        dataKey: 'status',
        title: this.$t('common.status')
        .toString(),
        sorter: true,
        width: 100,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          let setclass = '';
          if (data.entry.status === 'Due') {
            setclass = 'color: #005d84 !important';
          }
          if (data.entry.status === 'Urgent') {
            setclass = 'color: #ffab40 !important';
          }
          if (data.entry.status === 'Overdue') {
            setclass = 'color: #db1a20 !important';
          }
          if (data.entry.status === 'Expired') {
            setclass = 'color: #808080  !important';
          }
          return (
            <div style={ setclass }>{ data.entry.status }</div>
          ) as VNode;
        },
      },
      {
        key: 'expirationDate',
        dataKey: 'expirationDate',
        title: this.$t('quoteHistory.expDate')
        .toString(),
        sorter: true,
        width: 100,
        // tslint:disable-next-line:no-unused
      },
      {
        key: 'totalPrice',
        dataKey: 'totalPrice',
        title: this.$t('quoteHistory.amt')
        .toString(),
        sorter: true,
        width: 100,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div >
              {data.entry.totalPrice } USD
            </div>
          ) as VNode;
        },
      },
      {
        key: 'resellerManaged',
        dataKey: 'resellerManaged',
        title: this.$t('renewalManager.programManaged')
        .toString(),
        sorter: true,
        width: 200,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          const tempreseller = data.entry.resellerManaged.toLowerCase();
          const resellerManaged:boolean = (tempreseller === 'true');
          return (
            <div>
              <span class={['sw-flexbox', 'sw-flexbox--center-items']}>
                {<SwCheckbox name="resellercheckbox" props-checked={resellerManaged}
                nativeOn-click={ () => this.updateQuoteResellerManaged(data.entry.equoteId) } > </SwCheckbox>}
              </span>
            </div>
          ) as VNode;
        },
      },
      {
        key: 'programManaged',
        dataKey: 'programManaged',
        title: this.$t('renewalManager.resellerManaged')
        .toString(),
        sorter: true,
        width: 200,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          const tempprogram = data.entry.programManaged.toLowerCase();
          const programManaged:boolean = (tempprogram === 'true');
          return (
            <div style="display: flex !important;justify-content: space-between !important; align-items: center;">
              <div>
                {<SwCheckbox name="programcheckbox" props-checked={programManaged}
                nativeOn-click={ () => this.updateQuoteProgramManaged(data.entry.equoteId) } > </SwCheckbox>}
              </div>
              <div style="padding-left: 6rem">
                {<SwIconButton icon="pulse" v-tooltip={{
                  content: this.$t('quote.quoteActivity')
                  .toString(),
                  compact  : true,
                  placement: 'bottom',
                  maxWidth:275,
                } as TooltipDirValues}
                  nativeOn-click={() => this.showQuoteHistoryPopup(data.entry.equoteId) }></SwIconButton>}
                {<SwIconButton icon="register" v-tooltip={{
                  content: this.$t('quote.quoteNotes')
                  .toString(),
                  compact  : true,
                  placement: 'bottom',
                  maxWidth:275,
                } as TooltipDirValues}
                  nativeOn-click={() => this.showQuoteNotesPopup(data.entry.equoteId) }></SwIconButton>}
              </div>
            </div>
          ) as VNode;
        },
      },
    ];
    this.renewTablColumnConfig = tableConfig;
  }

  exportExcel() {
    const excelList: any = [];
    const keys = ['customer', 'equoteId', 'status', 'expirationDate', 'serviceStartDate', 'price', 'resellerManaged',
      'resellerCompany', 'productName', 'serialNumber', 'sku', 'friendlyName', 'salesStage', 'priceLocal',
      'servicePart', 'serviceType', 'serviceStartDate', 'serviceEndDate', 'interactionDate', 'interactionStatus', 'interactionNote'];
    const csvColumnHeader = ['Customer', 'Primary Quote Number ', 'Status', 'Quote Expiration', 'Service Expiration', 'Price', 'Reseller Managed',
      'Reseller Company', 'Product Name', 'Serial Number', 'SKU', 'Friendly Name', 'Sales Stage', 'Price Local',
      'Service Part', 'Service Type', 'Service Start Date', 'Service End Date', 'Interaction Date', 'Interaction Status', 'Interaction Note'];
    excelList.push(csvColumnHeader);
    let request: any;
    if (this.selectedTableRows.length > 0) {
      const selectedRows = this.selectedTableRows;
      const lstEquoteIdArr: any = [];
      selectedRows.forEach((data: any) => {
        lstEquoteIdArr.push(data.equoteId);
      });
      request = {
        status : this.tabid,
        equoteId : '',
        equoteStatus : '',
        country : '',
        state : '',
        customerName : '',
        amountFrom : '',
        amountTo : '',
        expiryDateFrom : '',
        expiryDateTo : '',
        quoteOwnership : '',
        partial : '',
        lstEquoteId: lstEquoteIdArr,
      };
    } else {
      request = {
        status : this.tabid,
        equoteId : '',
        equoteStatus : '',
        country : '',
        state : '',
        customerName : '',
        amountFrom : '',
        amountTo : '',
        expiryDateFrom : '',
        expiryDateTo : '',
        quoteOwnership : '',
        partial : '',
      };
    }
    this.$store.dispatch('RenewalManagerStoreModule/renewalManagerExport', request)
    .then((resp:any) => {
      if (resp.msgCode === 'MSWAPP:SUCCESS') {
        if (resp.partnerRespExportList.length > 0) {
          let tempArr: any = [];
          resp.partnerRespExportList.forEach((item: any, index: number) => {
            keys.forEach((keyName: string) => {
              item[keyName] === '' || item[keyName] === undefined || item[keyName] === null ? tempArr.push('') : tempArr.push(item[keyName]);
            });
            excelList.push(tempArr);
            tempArr = [];
            if (index === resp.partnerRespExportList.length - 1) {
              const csvContent = ''.concat(excelList.map((e:any) => e.join(','))
              .join('\n'));
              const blob = new Blob([(csvContent)]);
              const link:any = document.createElement('a');
              const url = URL.createObjectURL(blob);
              link.setAttribute('href', url);
              link.setAttribute('download', `${this.tabName}.csv`);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
            }
          });
        }
      }
    });
  }

  get tableHeight() {
    return 'calc(100vh - 415px)';
  }

  get getTableFooterConfig() : TableFooterConfig {
    const tableFooterConfig: TableFooterConfig = {
      // tslint:disable-next-line:no-unused
      render: (h: CreateElement): VNode => {
        return (
          <div class="sw-flexbox" style="background-color: white;">
            <span style="padding: 0.8rem 0.8rem 0 0.8rem; font-weight:700"> { `Total Records : ${this.totalQuotes}` }  </span>
            <span class="sw-flexbox__flex"></span>
            <span style="padding: 0.8rem 0.8rem 0 0.8rem;">{
              this.$t('renewalManager.statusDescription')
              .toString()
            }</span>
          </div>
        ) as VNode;
      },
    };
    return tableFooterConfig;
  }
  @Watch('quoteList')
  makeTableData() {
    const tableData = this.$store.getters['RenewalManagerStoreModule/getQuoteList'].map((el: any, index: any) => {
      return {
        ...el,
        _key: index,
      };
    });
    this.totalQuotes = tableData.length;
    this.renewTableData = tableData;
    this.tempRenewTableData = tableData;
  }

  async openQuoteDetails(val:string) {
    this.selectedQuoteId = val;
    this.showQuoteDetails = true;
  }

  async closeQuoteHistoryDialog() {
    this.showQuoteHistory = false;
    this.selectedQuoteId = '';
  }

  async closeQuoteNotesDialog() {
    this.showQuoteNotes = false;
    this.selectedQuoteId = '';
  }

  async showQuoteHistoryPopup(val:string) {
    this.selectedQuoteId = val;
    this.showQuoteHistory = true;
  }

  async showQuoteNotesPopup(val:string) {
    this.selectedQuoteId = val;
    this.showQuoteNotes = true;
  }

  onFilterClick(filterItem : any) {
    this.appliedFilter.map((ele: any, i: number) => {
      if (ele.value === '') {
        this.addFilterOptionBack.map((item: any, j: number) => {
          if (item.data.id === ele.id) {
            this.filterItems.splice(item.index, 0, item.data);
            this.addFilterOptionBack.splice(j, 1);
          }
        });
        this.appliedFilter.splice(i, 1);
      }
    });
    this.menuOpened = false;
    let removeIndex : number = -1;
    this.filterItems.forEach((element: any, i: number) => {
      if (element.id === filterItem) {
        removeIndex = i;
      }
    });
    if (removeIndex !== -1) {
      this.appliedFilter.push(
        { id: this.filterItems[removeIndex].id,
          content: this.filterItems[removeIndex].content,
          value: '',
        });
      this.filterSearch = '';
      this.showFilterSearch = true;
      this.addFilterOptionBack.push({
        index: removeIndex,
        data: this.filterItems[removeIndex],
      });
      this.filterItems.splice(removeIndex, 1);
    }
    setTimeout(() => {
      const filterInput = document.getElementById('filterTextField') as HTMLElement;
      if (filterInput) {
        filterInput.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         200);
  }

  initiateFilter(event : any, filterId : any) {
    if (event.keyCode === 13) {
      if (filterId === undefined) {
        this.applyFilter();
      } else {
        this.setFilterValue(event, filterId);
      }
    }
  }
  setFilterValue(event = undefined, id: any) {
    if (event !== undefined && this.filterSearch === '') {
      this.removeFilterBox(id);
    } else {
      this.appliedFilter.forEach((element : any) => {
        if (element.id === id) {
          if (event !== undefined) {
            element.value = this.filterSearch;
            this.showFilterSearch = false;
          }
        }
      });
      this.applyFilter();
    }
  }
  applyFilter(isExternal: boolean = false) {
    if (!isExternal) {
      this.renewTableData = this.tempRenewTableData;
    }
    if (this.appliedFilter.length > 0) {
      this.appliedFilter.forEach((element : any) => {
        this.renewTableData = this.renewTableData.filter((order : any) => {
          const elementValueArray = element.value.split(',');
          const srcValue = order[element.id].toUpperCase();
          let flag = 0;
          elementValueArray.every((elementValue : any) => {
            if (srcValue.indexOf(elementValue.trim()
            .toUpperCase()) >= 0) {
              flag = 1;
              return false;
            }
            if (srcValue.indexOf(elementValue.trim()
            .toUpperCase()) < 0) {
              return true;
            }
          });
          if (flag === 1) {
            return true;
          }
        });
      });
    }
    if (this.search !== '') {
      this.textExpanded = false;
      const key : string = this.search.toUpperCase();
      let flag : number = 0;
      const searchKeys = ['customer', 'equoteId', 'resellerDecideBy', 'status', 'expirationDate', 'totalPrice', 'resellerManaged', 'programManaged'];
      this.renewTableData = this.renewTableData.filter((item : any) => {
        flag = 0;
        searchKeys.forEach((field) => {
          if (item[field] && (item[field].toUpperCase()).indexOf(key) >= 0) {
            flag = 1;
            return false;
          }
          if (item[field] && (item[field].toUpperCase()).indexOf(key) < 0) {
            return true;
          }
        });
        if (flag === 1) {
          return true;
        }
      });
      this.showSearchedTextInHeader = true;
    }
  }
  removeFilterBox(val: any) {
    let removeIndex = -1;
    this.filterSearch = '';
    this.appliedFilter.forEach((element : any, i : number) => {
      if (element.id === val) {
        element.value = '';
        removeIndex = i;
      }
    });
    this.appliedFilter.splice(removeIndex, 1);
    this.addFilterOptionBack.map((item: any, i: number) => {
      if (item.data.id === val) {
        this.filterItems.splice(item.index, 0, item.data);
        this.addFilterOptionBack.splice(i, 1);
      }
    });
    this.applyFilter();
  }

  clearFilter() {
    this.search = '';
    this.showSearchedTextInHeader = false;
    this.applyFilter();
  }

  clearAllFilters() {
    this.appliedFilter.forEach((element : any) => {
      element.value = '';
    });
    this.appliedFilter = [];
    this.search = '';
    this.showFilterSearch = false;
    this.addFilterOptionBack.map((item: any) => {
      this.filterItems.splice(item.index, 0, item.data);
    });
    this.addFilterOptionBack = [];
    this.applyFilter();
  }

  updateQuoteProgramManaged(quoteid:string = '') {
    if (this.selectedTableRows.length > 0 && quoteid === '') {
      this.equoteIds = this.selectedTableRows.map((e:any) => e.equoteId);
    } else if (quoteid !== '') {
      this.equoteIds.push(quoteid);
    } else {
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: this.$t('renewalManager.prgmManagedMsg')
        .toString(),
      });
    }
    if (this.equoteIds.length > 0) {
      this.$store.dispatch('RenewalManagerStoreModule/updatequoteListForProgramManaged', { equoteIds: this.equoteIds })
      .then((res:any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK' && res.msgCode === 'MSWAPP:UPDATEQUOTE') {
          this.setQuoteDetails();
          this.makeTableData();
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
        }
      });
      this.equoteIds = [];
      this.clearSelectedRows();
    }
  }

  updateQuoteResellerManaged(quoteid:string = '') {
    if (this.selectedTableRows.length > 0 && quoteid === '') {
      this.equoteIds = this.selectedTableRows.map((e:any) => e.equoteId);
    } else if (quoteid !== '') {
      this.equoteIds.push(quoteid);
    } else {
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: this.$t('renewalManager.reselManagedMsg')
        .toString(),
      });
    }
    if (this.equoteIds.length > 0) {
      this.$store.dispatch('RenewalManagerStoreModule/updatequoteListForResellerManaged', { equoteIds: this.equoteIds })
      .then((res:any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK') {
          this.setQuoteDetails();
          this.makeTableData();
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
        }
      });
      this.equoteIds = [];
      this.clearSelectedRows();
    }
  }

  setQuoteDetails() {
    const req = {
      status : this.tabid,
      equoteId : '',
      equoteStatus : '',
      country : '',
      state : '',
      customerName : '',
      amountFrom : '',
      amountTo : '',
      expiryDateFrom : '',
      expiryDateTo : '',
      quoteOwnership : '',
      partial : '',
      serialNumber : '',
    };
    this.$store.dispatch('RenewalManagerStoreModule/fetchquoteList', req)
    .then((res:any) => {
      this.$store.commit('stopLoading');
      if (res.operationStatus === 'OK' && res.msgCode === 'MSWAPP:SUCCESS') {
        this.$store.commit('RenewalManagerStoreModule/setQuoteList', res.partnerRespList);
      }
    });
  }

  mounted() {
    const currentUser : any = localStorage.getItem(currentUserKey);
    this.isPartner = JSON.parse(currentUser).roles
        .includes('Partner');
    // console.warn(this.$route.params);
    // if (this.$route.params.snbuser && this.$route.params.snbuser !== '') {
    this.makeTableConfig();
    this.makeTableData();
    // }
  }

  onEntrySelecting(data: TableEntrySelectingEventData) {
    this.commonOnEntrySelecting(data);
  }

  commonOnEntrySelecting(data: TableEntrySelectingEventData) {
    if (data.selecting) {
      this.selectedTableRows.push(this.renewTableData[Number(data.entryKey)]);
    } else {
      const arrIndexes = this.selectedTableRows.map((item) => { return item._key; });
      const removeIndex = arrIndexes.indexOf(Number(data.entryKey));
      this.selectedTableRows.splice(removeIndex, 1);
    }
  }

  onCloseQuoteDetailsModal() {
    this.selectedQuoteId = '';
    this.showQuoteDetails = false;
    this.setQuoteDetails();
    this.makeTableData();
  }
  onClickReloadBtn() {
    this.setQuoteDetails();
    this.makeTableData();
  }
  filterTooltip(): TooltipDirValues {
    return {
      enabled: this.enableTooltip,
      placement: 'bottom',
      content: this.$t('common.filter')
      .toString(),
      includePopperForHover: true,
    };
  }
  searchTooltip(): TooltipDirValues {
    return {
      enabled: this.enableTooltip,
      placement: 'bottom',
      content: this.$t('common.search')
      .toString(),
      includePopperForHover: true,
    };
  }
  clearSelectedRows() {
    this.selectedTableRows = [];
    const vm = this.$refs.renewalTable as SwTable;
    if (vm) {
      vm.selectedSet.clear();
    }
    this.renewTableData = this.renewTableData.slice();
  }
}
